/**
 * ProtectedRoute - 受保護的路由組件
 * 要求用戶必須登入才能訪問
 * 可選：requireAdmin=true 要求管理員權限
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { isAuthenticated, loading, user } = useAuth();

  // 正在檢查登入狀態
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">載入中...</p>
        </div>
      </div>
    );
  }

  // 未登入則重定向到登入頁
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 需要管理員權限但用戶不是管理員
  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // 已登入且權限足夠則顯示內容
  return children;
}
